import { QueryGetHistogramArgs } from '@/lib/generated/graphql-types'
import {
  getJobTypeSalaryFiltersFromUrl,
  getStateSalaryFiltersFromUrl,
} from '@/modules/salary/filters/filter-utils'
import { SalaryPayPeriod } from '../table/constants'
import { isSearchableProfession } from '../trends/utils'

export function getSalaryHistogramInput({
  jobType,
  location,
  occupationSlug,
  payPeriod,
}: {
  jobType: string | undefined
  occupationSlug: string | undefined
  location: string | undefined
  payPeriod?: SalaryPayPeriod | null | undefined
}) {
  const normalizedJobType = getJobTypeSalaryFiltersFromUrl(jobType)
  const normalizedState = getStateSalaryFiltersFromUrl({
    location,
  })

  const input: QueryGetHistogramArgs['input'] = {}

  if (normalizedJobType) {
    input.jobType = normalizedJobType
  }
  if (normalizedState?.slugId) {
    input.location = normalizedState.slugId.toLowerCase()
  }
  if (payPeriod) {
    input.payPeriod = payPeriod
  }
  if (occupationSlug && isSearchableProfession(occupationSlug)) {
    input.profession = occupationSlug
  } else if (occupationSlug) {
    input.occupation = occupationSlug
  }

  return input
}
